export default __webpack_public_path__ + "static/blob13-7f25d1d717a90280464c024c778d79b3.svg";